<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    name: "app"
};
</script>

<style>
@import "./common/css/index.css";
.pageBar .el-pagination button,
.el-pagination span {
    padding: 0px 5px;
    color: #333333;
    border-radius: 4px;
}

.pageBar .el-pagination.is-background .btn-next,
.pageBar .el-pagination.is-background .btn-prev,
.pageBar .el-pagination.is-background .el-pager li {
    border-radius: 4px;
    color: #333333;
    background-color: #ffffff;
}
.pageBar .el-pagination.is-background .btn-next.disabled,
.pageBar .el-pagination.is-background .btn-next:disabled,
.pageBar .el-pagination.is-background .btn-prev.disabled,
.pageBar .el-pagination.is-background .btn-prev:disabled,
.pageBar .el-pagination.is-background .el-pager li.disabled {
    border-radius: 4px;
    color: #333333;
    /* background-color:#ffffff; */
}
.pageBar .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #037acc;
    border: 1px solid #037acc;
    color: #ffffff;
}
.pageBar .el-pagination.is-background .btn-next,
.pageBar .el-pagination.is-background .btn-prev,
.pageBar .el-pagination.is-background .el-pager li {
    border: 1px solid #e6e6e6;
    background-color: #ffffff;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    font-size: 0.69rem;
    overflow: hidden;
}
.titleLeft{
  font-weight: bold !important;
}
</style>
